import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';
import { usePress } from '../hooks/UNSAFE_usePress';
import { ViewHideIcon } from '../PRIVATE_ThemedIcons/ViewHideIcon';
import { ViewIcon } from '../PRIVATE_ThemedIcons/ViewIcon';
import { classNames } from '../utils/UNSAFE_classNames';
import { useComponentTheme } from '#hooks/UNSAFE_useComponentTheme';
import { ButtonLayoutRedwoodTheme } from '#UNSAFE_ButtonLayout/themes/redwood/ButtonLayoutTheme';
import { revealToggleIconBaseStyles } from './RevealToggleIconStyles.css';

type RevealToogleIconProps = {
  onPress: (event: Event) => void;
  isRevealed?: boolean;
};

export function RevealToggleIcon({ isRevealed, onPress }: RevealToogleIconProps) {
  const { pressProps } = usePress(onPress);
  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  // title attribute. We removed these because title is taking precedence over aria-label and this
  // is messing up the screen readers. To be accessible we are removing title and will implement
  // this as a <Tooltip> component when we have one.
  // TODO JET-51517 implement reveal icon title as a Tooltip
  // const hidePasswordStr = translations.inputPassword_hide();
  // const showPasswordStr = translations.inputPassword_show();
  const passwordMaskedStr = translations.inputPassword_hidden();

  // Because the RevealToggleIconStyles.css.ts uses buttonLayoutBaseTheme styles, we
  // need their vars to be loaded as well. This is why we are adding the buttonLayoutBaseTheme
  // style class.
  const { baseTheme: buttonLayoutBaseTheme } = useComponentTheme(ButtonLayoutRedwoodTheme);
  const styleClasses = classNames([buttonLayoutBaseTheme, revealToggleIconBaseStyles]);
  // TODO: Use toggle <Button> when that is available, JET-49207
  return (
    <button
      aria-label={passwordMaskedStr}
      role="switch"
      aria-checked={isRevealed ? false : true}
      class={styleClasses}
      tabIndex={0}
      {...pressProps}>
      {isRevealed ? <ViewHideIcon /> : <ViewIcon />}
    </button>
  );
}
